import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectAnalyticsUser } from '../../../selectors/analytics';
import { selectUserPhone } from '../../../selectors/user';
import { trackRequestFormShow } from '../../../utils/analytics';

export function useFormShowAnalytics(isFormOpen: boolean): void {
  const isSentRef = React.useRef<boolean>(false);
  const analyticsUser = useSelector(selectAnalyticsUser);
  const userPhone = useSelector(selectUserPhone);

  React.useEffect(() => {
    if (!isSentRef.current && isFormOpen) {
      trackRequestFormShow(userPhone, analyticsUser);
      isSentRef.current = true;
    }
  }, [analyticsUser, isFormOpen, userPhone]);
}
